import type { ReactNode } from 'react'
import { makeStyles, tokens, Card, Text, Button } from '@fluentui/react-components'
import { ErrorCircle24Regular } from '@fluentui/react-icons'

const useStyles = makeStyles({
  card: {
    padding: tokens.spacingVerticalXL,
    textAlign: 'center',
    maxWidth: '480px',
    margin: `${tokens.spacingVerticalXL} auto`,
    borderLeft: `4px solid ${tokens.colorPaletteRedBorderActive}`,
  },
  icon: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeHero700,
    marginBottom: tokens.spacingVerticalS,
  },
  title: {
    marginBottom: tokens.spacingVerticalXS,
  },
  message: {
    color: tokens.colorNeutralForeground3,
    marginBottom: tokens.spacingVerticalM,
  },
})

interface ErrorCardProps {
  title?: string
  message?: string
  retry?: () => void
  children?: ReactNode
}

export function ErrorCard({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
  retry,
  children,
}: ErrorCardProps) {
  const styles = useStyles()

  return (
    <Card className={styles.card}>
      <div className={styles.icon}>
        <ErrorCircle24Regular />
      </div>
      <Text weight="semibold" size={400} block className={styles.title}>
        {title}
      </Text>
      <Text size={300} block className={styles.message}>
        {message}
      </Text>
      {retry && (
        <Button appearance="primary" onClick={retry}>
          Try again
        </Button>
      )}
      {children}
    </Card>
  )
}
